import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { TuningTester } from './views/TuningTester';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<TuningTester />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.TuningTester)
	.setHudVisible(true)
	.build();

export default Layout;
